import React, { Component } from 'react';
import classNames from 'classnames';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const BookingSchema = Yup.object().shape({
  phone: Yup.string().required('Обязательное поле'),
  email: Yup.string()
    .email('Неверный почтовый адрес')
    .required('Обязательное поле'),
  comment: Yup.string(),
  checkin: Yup.string().required('Обязательное поле'),
  checkout: Yup.string().required('Обязательное поле'),
});

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: 0,
      days: 0,
      checkin: '',
      checkout: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  updateDays() {
    const { checkin, checkout } = this.state;
    if (!checkin || !checkout) {
      return;
    }
    const from = new Date(checkin);
    const to = new Date(checkout);
    const days = Math.round((to - from) / (1000 * 60 * 60 * 24));
    this.setState({ days });
  }

  updatePrice() {
    const { checkin, checkout } = this.state;
    const { prices } = this.props;

    let price = 0;
    const currentDate = new Date(checkin);
    const endDate = new Date(checkout);

    currentDate.setDate(currentDate.getDate() + 1);

    while (currentDate <= endDate) {
      price += +prices[currentDate.getMonth()];
      currentDate.setDate(currentDate.getDate() + 1);
    }
    this.setState({ price });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      this.updateDays();
      this.updatePrice();
    });
  }

  render() {
    const { room } = this.props;
    const {
      price, days, isSuccess, isError,
    } = this.state;
    return (
      <Formik
        initialValues={this.state}
        validationSchema={BookingSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.setState({ isSuccess: false, isError: true });
          fetch('https://us-central1-dom-yalta.cloudfunctions.net/booking', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...values,
              room,
              price,
              days,
            }),
          })
            .then(() => {
              setSubmitting(false);
              resetForm({
                checkin: '',
                checkout: '',
                email: '',
                phone: '',
                comment: '',
                days: 0,
                price: 0,
              });
              this.setState({
                isSuccess: true,
                isError: false,
                days: 0,
                price: 0,
              });
            })
            .catch(() => {
              setSubmitting(false);
              this.setState({
                isSuccess: false,
                isError: true,
                days: 0,
                price: 0,
              });
            });
        }}
        render={({
          values, errors, touched, isSubmitting, setFieldValue,
        }) => (
          <Form>
            <div className="box-title">Забронировать этот номер</div>
            <div className="box-content">
              {!isSubmitting && isSuccess && !isError ? (
                <p className="pararaph paragraph-success">
                  Ваш вопрос отправлен. Мы свяжемся с вами в скором времени
                </p>
              ) : null}
              {!isSubmitting && !isSuccess && isError ? (
                <p className="pararaph paragraph-error">Что-то пошло не так, попробуйте позже</p>
              ) : null}
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element calendar', {
                      error: errors.checkin && touched.checkin,
                    })}
                  >
                    <input
                      className="input"
                      type="date"
                      name="checkin"
                      placeholder="Заезд"
                      onChange={(e) => {
                        this.handleChange(e);
                        setFieldValue('checkin', e.target.value);
                      }}
                      value={values.checkin}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element calendar', {
                      error: errors.checkout && touched.checkout,
                    })}
                  >
                    <Field
                      className="input"
                      type="date"
                      name="checkout"
                      placeholder="Выезд"
                      onChange={(e) => {
                        this.handleChange(e);
                        setFieldValue('checkout', e.target.value);
                      }}
                      value={values.checkout}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element phone', {
                      error: errors.phone && touched.phone,
                    })}
                  >
                    <Field
                      className="input"
                      type="tel"
                      name="phone"
                      placeholder="Телефон"
                      value={values.phone}
                      onChange={(e) => {
                        this.handleChange(e);
                        setFieldValue('phone', e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element email', {
                      error: errors.email && touched.email,
                    })}
                  >
                    <Field
                      className="input"
                      type="email"
                      name="email"
                      placeholder="Почта"
                      value={values.email}
                      onChange={(e) => {
                        this.handleChange(e);
                        setFieldValue('email', e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element', {
                      error: errors.comment && touched.comment,
                    })}
                  >
                    <Field
                      component="textarea"
                      className="input"
                      name="comment"
                      placeholder="Коментарий"
                      rows={6}
                      value={values.comment}
                      onChange={(e) => {
                        this.handleChange(e);
                        setFieldValue('comment', e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-result">
                <div className="form-info">
                  <span className="form-result-item">Дней</span>
                  <span className="form-result-item">{days}</span>
                </div>
                <div className="form-info">
                  <span className="form-result-item">Цена</span>
                  <span className="form-result-sum">{`${price}р`}</span>
                </div>
              </div>
            </div>
            <button type="submit" className="btn" disabled={isSubmitting}>
              Забронировать
            </button>
          </Form>
        )}
      />
    );
  }
}

export default Booking;
